import { container } from "tsyringe";
import { Geo } from "./geo";

export function getSampleRate() {
  try {
    const geo = container.resolve(Geo).get();
    return geo.country === "US" ? 0.01 : 0.1;
  } catch (e) {
    return 0.01;
  }
}
